export default __webpack_public_path__ + "static/tyingTether-4ffa24506b52eefe79ea07a100f92aa2.svg";